(() => {
  const KEY = 'al_cart_reserved_until';
  const DEFAULT_SEC = 300;
  let timerId = null; 

  function format(sec) {
    const m = String(Math.floor(sec / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${m}:${s}`;
  }

  function getUntil(durationSec, resetTime = false) {
    const now = Math.floor(Date.now() / 1000);
    let until = Number(localStorage.getItem(KEY) || 0);

    if (!until || until <= now || resetTime) {
      until = now + durationSec;
      localStorage.setItem(KEY, String(until));
    }
    return until;
  }

  function initTimer(root = document, shouldResetTime = false) {
    const bar = (root.nodeType === 1 && root.matches('[data-sh-cart-reserved]')) 
      ? root 
      : root.querySelector?.('[data-sh-cart-reserved]');

    if (!bar) return;

    const out = bar.querySelector('[data-sh-timer]');
    const duration = Number(bar.getAttribute('data-duration') || DEFAULT_SEC);
    const until = getUntil(duration, shouldResetTime);

    bar.hidden = false;

    if (timerId) clearTimeout(timerId);

    const tick = () => {
      const now = Math.floor(Date.now() / 1000);
      const left = Math.max(0, until - now);
      
      if (out) out.textContent = format(left);

      if (left <= 0) return;
      timerId = setTimeout(tick, 250);
    };

    tick();
  }

  const obs = new MutationObserver((mutations) => {
    let foundNode = null;

    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('[data-sh-cart-reserved]') || node.querySelector?.('[data-sh-cart-reserved]')) {
          foundNode = node;
        }
      }
    }
    
    if (foundNode) {
      initTimer(foundNode, true);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    initTimer(document);
    obs.observe(document.documentElement, { childList: true, subtree: true });
  });
})();